import http from '@/api/common'

export default {
  getCalibrationRecommendations(make) {
    if (make !== undefined && make !== null) {
      return http.get(`calibrate/getCalibrationRecommendations?vehicleMake=${make}`)
    } else {
      return http.get('calibrate/getCalibrationRecommendations')
    }
  },
  getCalibrationRecommendation(id) {
    return http.get(`calibrate/getCalibrationRecommendation?id=${id}`)
  },
  saveCalibrationRecommendations(data) {
    return http.post('calibrate/saveCalibrationRecommendations', data)
  },
  deleteCalibrationRecommendation(id) {
    return http.get(`calibrate/deleteCalibrationRecommendation?id=${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/calibrate.js